import ENDPOINTS from 'api/endpoints';
import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { ProjectChangeLogResponse, ProjectLog } from './types';

export const getProjectChangeLogs = (
  accountId: string,
  projectId: string,
  maxLogNumber?: number,
  limit: number = 50,
) => {
  return doGet<ProjectChangeLogResponse>(
    generateNextPath(
      ENDPOINTS.PROJECT_CHANGE_LOGS,
      {
        accountId,
        projectId,
      },
      {
        max_log_number: maxLogNumber?.toString(),
        limit: limit.toString(),
      },
    ),
    LOGGER_TYPE.PROJECT,
  );
};

export const getDraftChangeLogs = (accountId: string, projectId: string) => {
  return doGet<ProjectLog[]>(
    generateNextPath(ENDPOINTS.DRAFT_CHANGE_LOGS, { accountId, projectId }),
    LOGGER_TYPE.PROJECT,
  );
};
